const GeneratorState = {
  GENERATING: "GENERATING",
  SAVING: "SAVING",
  FINISHED: "FINISHED"
};

export default Object.freeze(GeneratorState);